import { z } from 'zod';
import { ProductTypeDTO } from '../../../client';
import { PriceDTO } from '../../../server';
import { ProductDetailPromotionDTO } from './ProductDetailPromotionDTO';
import { ProductDetailVariantDTO } from './ProductDetailVariantDTO';

export const ProductDetailSetItemDTO = z
    .object({
        id: z.string(),
        defaultVariantId: z.string().nullish(),
        name: z.string(),
        imageUrl: z.string().nullish(),
        type: ProductTypeDTO,
        variants: z.array(ProductDetailVariantDTO),
        pricePerUnit: z.string().nullish(),
        promotion: ProductDetailPromotionDTO,
    })
    .and(PriceDTO);

export type ProductDetailSetItemDTO = z.infer<typeof ProductDetailSetItemDTO>;
